module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sekundaerlogo_postale_pos.c17918a2.png";